<template>
<section>
    <div class="loader" v-if="loading"></div>
    <section v-if="!loading">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group" >
                    <label>Select the domain</label>
                    <select class="form-control" v-model="newEmail.selectedDomain" v-on:change="domainChanged()">
                        <option value="">Select The Domain</option>
                        <option v-for="(account, index) in hostingAccounts" :value="index" :key="index + '_' + account.domain">
                            {{account.domain}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12" >
                <label>Username</label>
                <div class="input-group mb-3">
                    <input type="text" class="form-control" required v-model.trim="newEmail.username" placeholder="Your Email">
                    <div class="input-group-append" style="height: 38px">
                        <span class="input-group-text">{{(newEmail.selectedDomain==='')?'Select Domain':'@'+this.hostingAccounts[newEmail.selectedDomain].domain}}</span>
                    </div>
                </div>
                <span><small>You can use letters, numbers, periods, hyphen and underscores.</small></span><br>
                <span><small>Username can't have more then 64 characters</small></span><br>
            </div>
        </div>
<!--        <div class="row mt-3">-->
<!--            <div class="col-md-12">-->
<!--                <label>Security</label>-->
<!--                <div class="form-inline">-->
<!--                    <div class="form-check-radio mr-3">-->
<!--                        <label class="form-check-label">-->
<!--                            <input class="form-check-input" v-model="newEmail.security"  type="radio" name="password" id="password" value="password">  Set Password Now-->
<!--                            <span class="form-check-sign" for="password"></span>-->
<!--                        </label>-->
<!--                    </div>-->
<!--                    <div class="form-check-radio">-->
<!--                        <label class="form-check-label">-->
<!--                            <input class="form-check-input" v-model="newEmail.security" type="radio" name="alternate_email" id="alternate_email" value="alternate_email">  Provide alternate email-->
<!--                            <span class="form-check-sign" for="alternate_email"></span>-->
<!--                        </label>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <div class="row mt-3" v-if="newEmail.security === 'password'">
            <div class="col-md-12">
                <label>Password</label>
                <password class="" :secureLength="8" v-model="newEmail.password" autocomplete="off" defaultClass="form-control" :showPassword="true" :required="true" :badge="false" :requiredSpecialCharacter="false" />
            </div>
        </div>
        <div class="row mt-3" v-if="newEmail.security === 'alternate_email'">
            <div class="col-md-12">
                <label>Alternate Email</label>
                <input type="email" class="form-control" v-model.trim="newEmail.alternate_email">
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <label>Storage Space <i  class=" text-primary fa fa-question-circle" data-toggle="tooltip" data-placement="top" title="10GB is included between all email accounts for free, extra storage is $1/GB/mo. This does NOT count towards your WPO storage."></i></label>
                <div class="form-inline">
                    <div class="form-check-radio mr-3">
                        <label class="form-check-label">
                            <input class="form-check-input" v-model="newEmail.storageType" type="radio" name="limited" id="limited" value="limited">  Limited
                            <span class="form-check-sign" for="limited"></span>
                        </label>
                    </div>
                    <div class="form-check-radio">
                        <label class="form-check-label">
                            <input class="form-check-input" v-model="newEmail.storageType" type="radio" name="unlimited" id="unlimited" value="unlimited">  Unlimited
                            <span class="form-check-sign" for="unlimited"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="newEmail.storageType==='limited'">
            <div class="col-md-12">
                <div class="input-group mb-3">
                    <input type="number" class="form-control" placeholder="" v-model="newEmail.storage" >
                    <div class="input-group-append" style="height: 38px">
                        <span class="input-group-text">{{newEmail.storageUnit}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="row ">
                <div class="col-md-12">
                    <button class="btn btn-primary  pull-right" :disabled="checkingdomain" @click.prevent="addNewEmail()">Add New Email</button>
                    <button class="btn btn-default  pull-right "  v-if="emailSetupFlag" data-dismiss="modal" aria-label="Close">Cancel</button>
                </div>
            </div>
        </div>

    </section>


</section>
</template>

<script>
    import { db } from "@/firebase/init";
    import tooltips from "../../../mixins/tooltips";
    import swal from "sweetalert2";
    import Password from "../Sites/ViewHostingDetails/Ftp/PasswordStrengthMeter";
    export default {
        name: "AddNewEmail",
        components: {
            Password
        },
        computed: {
            asyncDone() {
                return this.$store.getters["async/state"];
            },
            hostingAccounts() {
                return this.$store.getters["hosting/accountsOrdered"];
            },
            userUId() {
                return this.$store.getters.getUID;
            },
            emailSetupFlag(){
                return this.$store.state.emailSetup;
            }
        },
        mixins: [tooltips],
        data(){
            return{
                loading:false,
                checkingdomain:false,
                newEmail:{
                    selectedDomain:'',
                    security:'password',
                    username:'',
                    password:'',
                    alternate_email:'',
                    storageType:'unlimited',
                    storage:1024,
                    storageUnit:'MB',
                },
            }
        },
        created(){
          // this.$http.post('email/list-account',{
          //       grant_type:'token',
          //       domain:'mydedicatedservers.com',
          //       username:'xzbzxotmveun',
          //       searchType:'domain'
          //   });
        },
        methods:{
            domainChanged(){
                this.checkingdomain = true;
                db.collection('users').doc(this.userUId).get()
                    .then(async doc => {
                        if (doc.data().emailSetupFlag) {
                            if (!doc.data().allDomians || !doc.data().allDomians.includes(this.hostingAccounts[this.newEmail.selectedDomain].domain)) {
                                this.$parent.closePopup(this.newEmail.selectedDomain);
                                this.newEmail = {
                                    selectedDomain:'',
                                    security:'password',
                                    username:'',
                                    password:'',
                                    alternate_email:'',
                                    storageType:'unlimited',
                                    storage:1024,
                                    storageUnit:'MB',
                                };
                                this.checkingdomain = false;
                            }else{
                                this.checkingdomain = false;
                            }
                        }
                    });
            },
            async addNewEmail(){
                console.log(this.hostingAccounts[this.newEmail.selectedDomain]);
                if(this.newEmail.selectedDomain!=='' && this.newEmail.username!==''&& this.newEmail.security!==''&& this.newEmail.storageType!=='' && ((this.newEmail.security === 'alternate_email' && this.newEmail.alternate_email !=='') || (this.newEmail.security === 'password' && this.newEmail.password !=='')) && ((this.newEmail.storageType ==='limited' && this.newEmail.storage !=='') || this.newEmail.storageType ==='unlimited')){
                    let storage = (this.newEmail.storageType === 'limited')?this.newEmail.storage:0;
                    let username='';
                    this.loading = true;
                    db.collection('users').doc(this.userUId).get()
                        .then(async doc => {
                            if(doc.data().emailSetupFlag){
                                username = doc.data().emailUsernames.username;
                                this.$http.post('email/add-pop',{
                                    grant_type:'token',
                                    domain:this.hostingAccounts[this.newEmail.selectedDomain].domain,
                                    email:this.newEmail.username,
                                    password:this.newEmail.password,
                                    storage:storage,
                                    username:username,
                                    ip:this.hostingAccounts[this.newEmail.selectedDomain].serverIP
                                }).then(async resp=>{
                                    let parsedJsonResponse = resp.data;
                                    if(parsedJsonResponse.result.errors === null){
                                        let emailAccounts=[];
                                        await db.collection('users').doc(this.userUId).get()
                                            .then(async doc => {
                                                if (doc.data().emailAccounts) {
                                                    emailAccounts = doc.data().emailAccounts
                                                }
                                            });
                                        let obj={
                                            email :this.newEmail.username+'@'+this.hostingAccounts[this.newEmail.selectedDomain].domain,
                                            password:this.newEmail.password
                                        };
                                        emailAccounts.push(obj);
                                        await db.collection("users").doc(this.userUId).update({
                                            emailAccounts: emailAccounts,
                                        });
                                        swal('Success', 'Email has been created successfully!', 'success');
                                        this.$store.state.emailSetup = true;
                                        this.newEmail = {
                                            selectedDomain:'',
                                            security:'password',
                                            username:'',
                                            password:'',
                                            alternate_email:'',
                                            storageType:'unlimited',
                                            storage:1024,
                                            storageUnit:'MB',
                                        };
                                        this.$parent.closePopup();
                                        this.loading = false;
                                    }else{
                                        swal('Error', parsedJsonResponse.result.errors[0], 'error');
                                        this.loading = false;
                                    }
                                }).catch(()=>{
                                    swal('Error', 'Something went wrong!', 'error');
                                    this.loading = false;
                                });
                            }else{
                                swal('Error', 'Please make sure you have setup your email account.', 'error');
                                this.loading = false;
                            }
                        });
                }else{
                    swal('Error', 'All fields are required.', 'error');
                }
            },
        }
    }
</script>

<style scoped>
    .Password{
        max-width: 100% !important;
    }
</style>
